import { GroupMode, Run, Task } from '@bringg/types';

import { fieldValueGetter } from 'bringg-web/features/monitoring/shared/realtime-updates/updates/field-value-getter';

function create(item: Task | Run, groupIdFields: string[], fallback?: Task | Run): string {
	if (!item) {
		return;
	}

	if (groupIdFields.length === 0) {
		return GroupMode.None;
	}

	return groupIdFields
		.map(field => {
			return fieldValueGetter.get(item, fallback, field) || 'null';
		})
		.join('-');
}

export const groupIdCreator = { create };
